import { useRef } from "react";

function useIsPrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();
  const prev = ref.current;
  ref.current = value;
  return prev;
}

export default useIsPrevious;
